<template>
  <div class="home-page pt-16">
    <div class="top-box">
      <p class="font-primary-title mb-6">
        {{ $vuetify.lang.t("$vuetify.home.index.25Aa4Fc745150030") }}<br />{{
          $vuetify.lang.t("$vuetify.home.index.2D6Ecf8Faaa8B124")
        }}
      </p>
      <p class="font-secondary-sub">
        {{ $vuetify.lang.t("$vuetify.home.index.1Db26267D1041223") }}
      </p>
      <!-- <p class="font-primary-sub mt-16">邀请新用户注册，送 $10 金奖励</p> -->
      <v-btn
        light
        class="register-btn mt-4"
        v-if="!getIsLogin"
        color="#FFCA00"
        :height="64"
        @click="$router.push('/register')"
        ><span class="font-primary-dark-24">{{
          $vuetify.lang.t("$vuetify.home.index.F8E18C90C3E35618")
        }}</span></v-btn
      >
    </div>
    <div class="banner-box">
      <div class="banner-content">
        <swiper :options="swiperOptions">
          <swiper-slide
            v-for="item in noticeList"
            :key="item.id"
            :data-id="item[0].id"
          >
            <div
              class="slide-item text-truncate pr-4 _a"
              v-for="item2 in item"
              :key="item2.id"
            >
              {{ item2.title }}
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="content-box">
      <p class="font-primary-sub-title">
        {{ $vuetify.lang.t("$vuetify.home.index.29761532Fc8Ebecc") }}
      </p>
      <div class="d-flex trade-box">
        <div class="trade-left">
          <div class="title-box d-flex justify-space-between align-center pa-7">
            <span class="font-primary-23">{{
              $vuetify.lang.t("$vuetify.home.index.D8A95E4506487452")
            }}</span>
            <span class="font-secondary-14 _a" @click="$router.push('/delivery')"
              >{{ $vuetify.lang.t("$vuetify.home.index.5Bd31Fab681C6E9D")
              }}<v-icon color="#898C97">mdi-arrow-right-thin</v-icon></span
            >
          </div>
          <div class="list-box pa-2 pt-6">
            <div class="th-box d-flex justify-space-between">
              <div class="th-item font-secondary-14">
                {{ $vuetify.lang.t("$vuetify.home.index.010Ae07A09Caf221") }}
              </div>
              <div class="th-item font-secondary-14">
                {{ $vuetify.lang.t("$vuetify.home.index.F4D875118E6D6Dbb") }}
              </div>
              <div class="th-item font-secondary-14">
                {{ $vuetify.lang.t("$vuetify.home.index.3Dfdfb3D6599100E") }}
              </div>
              <div class="th-item th-item2 font-secondary-14 text-right ">
                {{ $vuetify.lang.t("$vuetify.home.index.28Fb39Bd41E54242") }}
              </div>
              <div class="th-item th-item2 font-secondary-14">
                {{ $vuetify.lang.t("$vuetify.home.index.29761532Fc8Ebecc") }}
              </div>
            </div>
            <div
              class="td-box d-flex justify-space-between align-center"
              v-for="item in contractList"
              :key="item.id"
            >
              <div class="td-item font-primary-17 d-flex align-center">
                <img :src="item.logo" width="37" class="mr-2" alt="" />
                {{ item.symbol }}
              </div>
              <div class="td-item font-primary-18">
                {{ lastData && lastData[item.id] && lastData[item.id].close }}
              </div>
              <div
                class="td-item font-primary-18"
                :class="
                  lastData[item.id] && lastData[item.id].range > 0
                    ? 'green-color'
                    : lastData[item.id] && lastData[item.id].range < 0
                    ? 'red-color'
                    : 'grey-color'
                "
              >
                {{ lastData[item.id] && lastData[item.id].range > 0 ? "+" : ""
                }}{{
                  toFixed(
                    lastData && lastData[item.id] && lastData[item.id].range,
                    2
                  )
                }}%
              </div>
              <div class="td-item td-item2 font-primary-18 d-flex justify-end">
                <SimpleChart
                  v-if="loadKlineData"
                  :klineData="kLineData[item.id]"
                  :colorType="
                    lastData[item.id] && lastData[item.id].range >= 0
                      ? 'green'
                      : 'red'
                  "
                />
              </div>
              <div class="td-item td-item2 font-primary-17">
                <button class="trade-btn" @click="$router.push('/flash')">
                  {{ $vuetify.lang.t("$vuetify.home.index.29761532Fc8Ebecc") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="trade-right">
          <div class="title-box d-flex justify-space-between align-center pa-7">
            <span class="font-primary-23">{{
              $vuetify.lang.t("$vuetify.home.index.B47A3911Bacd94C6")
            }}</span>
            <span class="font-secondary-14 _a" @click="$router.push('/delivery')"
              >{{ $vuetify.lang.t("$vuetify.home.index.5Bd31Fab681C6E9D")
              }}<v-icon color="#898C97">mdi-arrow-right-thin</v-icon></span
            >
          </div>
          <div class="list-box pa-2 pt-6">
            <div class="th-box d-flex justify-space-between">
              <div class="th-item font-secondary-14">
                {{ $vuetify.lang.t("$vuetify.home.index.010Ae07A09Caf221") }}
              </div>
              <div class="th-item font-secondary-14">
                {{ $vuetify.lang.t("$vuetify.home.index.F4D875118E6D6Dbb") }}
              </div>
              <div class="th-item font-secondary-14">
                {{ $vuetify.lang.t("$vuetify.home.index.3Dfdfb3D6599100E") }}
              </div>
            </div>
            <div
              class="td-box d-flex justify-space-between align-center"
              v-for="item in rangeList"
              :key="item.id"
            >
              <div class="td-item font-primary-17 d-flex align-center">
                <img :src="item.logo" width="37" class="mr-2" alt="" />{{
                  item.symbolName
                }}
              </div>
              <div class="td-item font-primary-17">{{ item.close }}</div>
              <div
                class="td-item font-primary-17"
                :class="
                  item.range > 0
                    ? 'green-color'
                    : item.range < 0
                    ? 'red-color'
                    : 'grey-color'
                "
              >
                {{ item.range > 0 ? "+" : "" }}{{ toFixed(item.range, 2) }}%
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="openMining">
        <p class="font-primary-sub-title mt-16">
          {{ $vuetify.lang.t("$vuetify.setting.liquidity") }}
        </p>
        <div class="mining-box d-flex align-center justify-space-between">
          <div class="mining-left">
            <p class="font-primary-33 mb-1">
              {{ $vuetify.lang.t("$vuetify.home.index.712910D574F43D95") }}
            </p>
            <p class="font-secondary-18">
              {{ $vuetify.lang.t("$vuetify.home.index.5507Fd830D7Bf51F") }}
            </p>
            <p class="font-secondary-14 mb-0 rate-label">
              {{ $vuetify.lang.t("$vuetify.home.index.7De3D636A165E008") }}
            </p>
            <p class="rate-text green-color">{{ minRate }}%~{{ maxRate }}%</p>
            <v-btn
              :height="52"
              class="mining-btn mt-4"
              light
              color="#FFCA00"
              @click="$router.push('/invest')"
              >{{
                $vuetify.lang.t("$vuetify.home.index.B853F96626106912")
              }}</v-btn
            >
          </div>
          <div class="mining-box2 d-flex align-center" v-if="miningList.length > 0">
            <div class="box-item">
              <div class="d-flex align-center justify-space-between mb-6">
                <p class="font-primary-29 mb-0">
                  {{ miningList[0].coinStandard.coinName
                  }}{{ $vuetify.lang.t("$vuetify.setting.liquidity") }}
                </p>
                <img
                  :src="miningList[0].coinStandard.logo"
                  width="50"
                  height="50"
                  alt=""
                />
              </div>
              <p class="font-secondary-19">
                {{ miningList[0].daysMin }}～{{ miningList[0].daysMax
                }}{{ $vuetify.lang.t("$vuetify.home.index.213B5C96Be7Cd1F8")
                }}{{ miningList[0].annualRateReturnMin }}%～{{
                  miningList[0].annualRateReturnMax
                }}% {{ $vuetify.lang.t("$vuetify.home.index.213B5C96Be7Cd1F9")
                }}{{ miningList[0].maxQuantity
                }}{{ miningList[0].coinStandard.coinName }}
              </p>
              <button
                class="details-btn"
                style="margin-top: 100px"
                @click="$router.push('/invest')"
              >
                {{ $vuetify.lang.t("$vuetify.home.index.Dc710Cffe6313Bb5") }}
              </button>
            </div>
            <div class="box-item">
              <div class="d-flex align-center justify-space-between mb-6">
                <p class="font-primary-29 mb-0">
                  {{ miningList[1].coinStandard.coinName
                  }}{{ $vuetify.lang.t("$vuetify.setting.liquidity") }}
                </p>
                <img
                  :src="miningList[1].coinStandard.logo"
                  width="50"
                  height="50"
                  alt=""
                />
              </div>
              <p class="font-secondary-19">
                {{ miningList[1].daysMin }}～{{
                  miningList[1].daysMax
                }}天，年化利率{{ miningList[1].annualRateReturnMin }}%～{{
                  miningList[1].annualRateReturnMax
                }}% 最大可买{{ miningList[1].maxQuantity
                }}{{ miningList[1].coinStandard.coinName }}
              </p>
              <button class="details-btn" style="margin-top: 100px">
                {{ $vuetify.lang.t("$vuetify.home.index.Dc710Cffe6313Bb5") }}
              </button>
            </div>
          </div>
        </div>
      </template>

      <div class="d-flex justify-space-between align-center mt-16 mb-4">
        <p class="font-primary-sub-title mb-0">
          {{ $vuetify.lang.t("$vuetify.home.index.B92Ffc837Ecaa1Dd") }}
        </p>
        <p class="font-secondary-14 mb-0 _a" @click="$router.push('/news')">
          {{ $vuetify.lang.t("$vuetify.home.index.5Bd31Fab681C6E9D")
          }}<v-icon color="#898C97">mdi-arrow-right-thin</v-icon>
        </p>
      </div>
      <div class="news-box d-flex">
        <div class="item pa-6" v-for="item in newsList" :key="item.id">
          <p class="font-secondary-14 mb-0">
            {{ new Date(item.createTime).toLocaleDateString() }}
          </p>
          <p class="title-text font-primary-23 mt-4">{{ item.title }}</p>
          <p class="sub-text font-secondary-14">
            {{ item.text }}
          </p>
          <button
            class="details-btn"
            style="margin-top: 50px"
            @click="$router.push(`/news/details?id=${item.id}`)"
          >
            {{ $vuetify.lang.t("$vuetify.home.index.Dc710Cffe6313Bb5") }}
          </button>
        </div>
      </div>
      <div class="about-box">
        <p class="font-primary-sub-title">
          {{ $vuetify.lang.t("$vuetify.home.index.6C18D67F6D19586B") }}
        </p>
        <div class="d-flex justify-space-between pb-16">
          <p class="about-text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {{ $vuetify.lang.t("$vuetify.home.index.6342E3C33Cb48Cd5")
            }}<br />{{
              $vuetify.lang.t("$vuetify.home.index.198Efc4254683Eef")
            }}
          </p>
          <img
            class="about-img"
            src="../../../public/image/home/platform2.png"
            width="540"
            alt=""
          />
        </div>
      </div>
      <div class="advantages-box">
        <p class="font-primary-sub-title mb-6">
          {{ $vuetify.lang.t("$vuetify.home.index.E710339D9576292E") }}
        </p>
        <div class="d-flex advantages-content">
          <div class="item text-center pl-10 pr-10">
            <img
              src="../../../public/image/home/advantage1.png"
              height="70"
              alt=""
              class="mt-16"
            />
            <p class="font-primary-21 mt-10 mb-10 text-no-wrap">
              {{ $vuetify.lang.t("$vuetify.home.index.F9Ce8B2C63885B26") }}
            </p>
            <p class="font-secondary-17 text-center">
              {{ $vuetify.lang.t("$vuetify.home.index.C4D0A2C9Ff0305Ce") }}
            </p>
          </div>
          <div class="item text-center pl-10 pr-10">
            <img
              src="../../../public/image/home/advantage2.png"
              height="70"
              alt=""
              class="mt-16"
            />
            <p class="font-primary-21 mt-10 mb-10 text-no-wrap">
              {{ $vuetify.lang.t("$vuetify.home.index.2E8708Ee3F11Cc1A") }}
            </p>
            <p class="font-secondary-17 text-center">
              {{ $vuetify.lang.t("$vuetify.home.index.Bb12Cbcf89C56C5C") }}
            </p>
          </div>
          <div class="item text-center pl-10 pr-10">
            <img
              src="../../../public/image/home/advantage3.png"
              height="70"
              alt=""
              class="mt-16"
            />
            <p class="font-primary-21 mt-10 mb-10 text-no-wrap">
              {{ $vuetify.lang.t("$vuetify.home.index.Aa4723Bfbf6808F4") }}
            </p>
            <p class="font-secondary-17 text-center">
              {{ $vuetify.lang.t("$vuetify.home.index.1Bf0204B7D3Ee230") }}
            </p>
          </div>
          <div class="item text-center pl-10 pr-10">
            <img
              src="../../../public/image/home/advantage4.png"
              height="70"
              alt=""
              class="mt-16"
            />
            <p class="font-primary-21 mt-10 mb-10 text-no-wrap">
              {{ $vuetify.lang.t("$vuetify.home.index.2E7Dfd53D26F7224") }}
            </p>
            <p class="font-secondary-17 text-center">
              {{ $vuetify.lang.t("$vuetify.home.index.1C65453103B5Fcc3") }}
            </p>
          </div>
        </div>
      </div>
      <div class="download-box">
        <p class="font-primary-sub-title mb-2">
          {{ $vuetify.lang.t("$vuetify.home.index.85Ac49Ece9Dcc80B") }}
        </p>

        <div class="qrcode-box d-flex align-center">
          <!--<img src="../../../public/image/home/qrcode.png" width="195" alt="" /> -->
          <div class="qrbox">
            <qrcode-vue :value="qrCode" ref="qrcode" size="180"> </qrcode-vue>
          </div>
          <div class="qrLabel ml-8">
            <p class="font-secondary-17 mb-1">
              {{ $vuetify.lang.t("$vuetify.home.index.2Bf52Ce75E29Fc88") }}
            </p>
            <p class="font-primary-23">
              {{ $vuetify.lang.t("$vuetify.home.index.04Ee893775563F26") }}</p>
          </div>
        </div>
        <div class="d-flex mt-12">
          <div
            class="btn-item d-flex justify-space-between align-center mr-5 pl-3 pr-3"
          >
            <div class="d-flex align-center">
              <img src="../../../public/image/home/android.png" alt="" />
              <span class="font-primary-17 ml-5">{{
                $vuetify.lang.t("$vuetify.home.index.88D1422B33571066")
              }}</span>
            </div>
          </div>
          <div
            class="btn-item d-flex justify-space-between align-center pl-3 pr-3"
          >
            <div class="d-flex align-center">
              <img src="../../../public/image/home/ios.png" alt="" />
              <span class="font-primary-17 ml-5">{{
                $vuetify.lang.t("$vuetify.home.index.04Ee893775563F21")
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import SimpleChart from "@/components/SimpleChart.vue";
import QrcodeVue from "qrcode.vue";
export default {
  data() {
    return {
      noticeList: [],
      //   contractList: [],
      rangeList: [],
      //   allIds: [],
      kLineData: {},
      loadKlineData: false,
      lastData: {},
      miningList: [],
      minRate: "",
      maxRate: "",
      newsList: [],
      selectLang: "",
      timer: null,
      swiperOptions: {
        direction: "vertical",
        autoplay: true,
        loop: true,
        on: {
          click: (swiper, event) => {
            let tmp = this.noticeList.flat().filter((i) => {
              return i.title == swiper.target.innerText;
            });
            if (tmp.length > 0) {
              this.$router.push(`/notice/details?id=${tmp[0].id}`);
            }
          },
        },
      },
    };
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
    this.timer = null;
  },
  components: {
    Swiper,
    SwiperSlide,
    SimpleChart,
    QrcodeVue,
  },
  directives: {
    swiper: directive,
  },
  computed: {
    ...mapGetters(["getLanguageList", "getSymbolList", "getConfigData","getIsLogin"]),
    qrCode() {
      return location.origin + "/h5/#/download";
    },
    openMining() {
      return this.getConfigData.openMining;
    },
    contractList() {
      if (this.getSymbolList.length == 0) {
        return [];
      }
      return this.getSymbolList.slice(0, 5);
    },
    allIds() {
      if (this.getSymbolList.length == 0) {
        return;
      }
      return this.getSymbolList.map((item) => {
        return item.id;
      });
    },
  },
  created() {
    this.getBasisArticleList();
    this.getBasisArticleDetailList();
    this.getMiningProduct();
    this.initData();
    this.selectLang = localStorage.getItem("lang") || "ENGLISH";
    // this.getQuotes();
    // this.getPerpetualVarieties();
  },
  methods: {
    ...mapActions([
      "basisArticleListFetch",
      "symbolListFetch",
      "quotesGetNewListFetch",
      "quotesFetch",
      "quotesHistoryFetch",
      "miningProductFetch",
      "basisArticleDetailListFetch",
    ]),
    ...mapMutations(["setInvestData"]),
    changeLang() {
      localStorage.setItem("lang", this.selectLang);
    },
    async initData() {
      await this.getSymbolListFuc();
      this.getQuotes("range");
      await this.getAllKline();
      this.getQuotesGetNewList();
      this.loopQuotes();
    },
    async getMiningProduct() {
      let res = await this.miningProductFetch();
      let obj = {};
      res.data.forEach((item) => {
        try {
          obj[item.standardId].push(item);
        } catch (error) {
          obj[item.standardId] = [item];
        }
      });
      let formatData = [];
      for (let id in obj) {
        let annualRateReturnDayMin,
          annualRateReturnDayMax,
          minQuantity,
          maxQuantity,
          daysMin,
          daysMax,
          annualRateReturnMin,
          annualRateReturnMax;

        annualRateReturnMin = Math.min(
          ...obj[id].map((item) => {
            return item.annualRateReturn;
          })
        );
        annualRateReturnMax = Math.max(
          ...obj[id].map((item) => {
            return item.annualRateReturn;
          })
        );

        annualRateReturnDayMin = Math.min(
          ...obj[id].map((item) => {
            return item.annualRateReturnDay;
          })
        );

        annualRateReturnDayMax = Math.max(
          ...obj[id].map((item) => {
            return item.annualRateReturnDay;
          })
        );
        minQuantity = Math.min(
          ...obj[id].map((item) => {
            return item.minQuantity;
          })
        );
        maxQuantity = Math.max(
          ...obj[id].map((item) => {
            return item.maxQuantity;
          })
        );

        daysMin = Math.min(
          ...obj[id].map((item) => {
            return item.days;
          })
        );
        daysMax = Math.max(
          ...obj[id].map((item) => {
            return item.days;
          })
        );
        formatData.push({
          // symbol:
          coinStandard: obj[id][0].coinStandard,
          standardId: id,
          annualRateReturnDayMin,
          annualRateReturnDayMax,
          annualRateReturnMin,
          annualRateReturnMax,
          minQuantity,
          maxQuantity,
          daysMin,
          daysMax,
          products: obj[id],
        });
      }
      this.miningList = formatData.slice(0, 2);
      this.minRate = Math.min(
        ...formatData.map((item) => {
          return item.annualRateReturnMin;
        })
      );
      this.maxRate = Math.max(
        ...formatData.map((item) => {
          return item.annualRateReturnMax;
        })
      );
      this.setInvestData(formatData);
    },
    loopQuotes() {
      this.timer = setInterval(() => {
        this.getQuotesGetNewList();
      }, 3000);
    },
    async getAllKline() {
      let res = await Promise.all([
        this.getQuotesHistory(this.contractList[0].id),
        this.getQuotesHistory(this.contractList[1].id),
        this.getQuotesHistory(this.contractList[2].id),
        this.getQuotesHistory(this.contractList[3].id),
        this.getQuotesHistory(this.contractList[4].id),
      ]);
      this.kLineData[this.contractList[0].id] = res[0];
      this.kLineData[this.contractList[1].id] = res[1];
      this.kLineData[this.contractList[2].id] = res[2];
      this.kLineData[this.contractList[3].id] = res[3];
      this.kLineData[this.contractList[4].id] = res[4];

      this.loadKlineData = true;
    },
    async getQuotes(orderBy) {
      let res = await this.quotesFetch({
        orderBy,
        isAsc: false,
      });
      if (res.errCode == 0) {
        this.rangeList = res.data.slice(0, 5);
      }
    },
    async getQuotesHistory(id) {
      let res = await this.quotesHistoryFetch({
        symbolId: id,
        period: "1min",
      });
      if (res.errCode == 0) {
        return res.data;
      }
      return null;
    },
    async getSymbolListFuc() {
      let res = await this.symbolListFetch();
      if (res.errCode == 0) {
        // this.allIds = res.data.map((item) => {
        //   return item.id;
        // });
        // this.contractList = res.data.slice(0, 5);
        // this.setSymbolList(res.data);
      }
    },
    async getQuotesGetNewList() {
      let res = await this.quotesGetNewListFetch({
        symbolIds: JSON.stringify(this.allIds),
        // period: "1min",
      });
      if (res.errCode == 0) {
        this.rangeList = this.rangeList.map((item) => {
          return {
            ...item,
            close: res.data[item.symbolId].close,
            range: res.data[item.symbolId].range,
          };
        });
        let newQuoteData = res.data;
        let tmp = {};
        for (let id in this.kLineData) {
          let newData = newQuoteData[id];
          tmp[id] = {
            close: newData.close,
            range: newData.range,
          };
          this.lastData = JSON.parse(JSON.stringify(tmp));
          let idx = this.kLineData[id].findIndex((item) => {
            return item["kid"] == newData["kid"];
          });
          if (idx > -1) {
            let tmp2 = JSON.parse(JSON.stringify(this.kLineData[id]));
            tmp2[idx] = newData;
            this.kLineData[id] = [...tmp2];
          } else {
            let tmp2 = this.kLineData[id].slice(1);
            this.kLineData[id] = [...tmp2, newData];
          }
        }
      }
    },
    async getBasisArticleList() {
      let res = await this.basisArticleListFetch({
        typeId: 6,
        pageNum: 0,
        pageSize: 30,
      });
      if (res.errCode == 0) {
        let tmp = [];
        for (let i = 0; i < res.data.content.length; ) {
          tmp.push(res.data.content.slice(i, i + 3));
          i += 3;
        }
        this.noticeList = tmp;
      }
    },
    async getBasisArticleDetailList() {
      let res = await this.basisArticleDetailListFetch({
        typeId: 2,
        pageNum: 0,
        pageSize: 3,
      });
      if (res.errCode == 0) {
        this.newsList = res.data.content.map((item) => {
          let _text = item.text.replaceAll("<p>", "");
          _text = _text.replaceAll("</p>", "");
          _text = _text.replaceAll("<br>", "");
          _text = _text.replaceAll("<br />", "");
          return {
            ...item,
            text: _text,
          };
        });
      }
    },
  },
};
</script>
    <style lang="scss" scoped>
.home-page {
  background-image: url("../../../public/image/home/background.jpg");
  background-color: #0c0d10;
  @media (max-width: 1500px) {
    .top-box,
    .banner-content,
    .foot-content {
      padding-left: 40px !important;
      padding-right: 40px !important;
    }
  }
  @media (max-width: 768px) {
    .box-item {
      width: 100%;
    }
    .font-primary-33 {
      font-size: 22px;
    }
    .rate-text {
      font-size: 30px;
    }
    .banner-box {
      height: 50px;
    }
    .banner-content {
      padding-left: 40px !important;
      padding-right: 10px !important;
      height: 50px;
      background-position: 0px 8px;
    }
    .content-box {
      padding: 10px;
    }
    .top-box {
      background-size: 80%;
      background-position: center;
      padding-top:20px;
      padding-bottom: 20px;
      padding-left: 20px !important;
      padding-right: 20px !important;
    }
    .swiper-slide {
      line-height: 50px;
    }
    .trade-box {
      flex-wrap: wrap;
      .trade-left {
        width: 100%;
        margin-bottom: 20px;
      }
      .trade-right {
        width: 100%;
      }
    }
    .th-item2,.td-item2 {
      display: none !important;
    }
    .mining-box{
      flex-wrap: wrap;
      padding: 10px;
      .mining-left {
        width: 100%;
        margin-bottom:20px;
      }
    }
    .mining-box2  {
      flex-wrap: wrap;
      .box-item {
        margin-top:10px; 
      }
    }
    .news-box {
      flex-wrap: wrap;
      .item {
        width: 100%;
        margin-bottom:10px;
      }
    }
    .about-box {
      margin-top: 50px;
      .about-img {
        display: none;
      }
    }
    .advantages-box {
      margin-top: 50px;
      .advantages-content {
        flex-wrap: wrap;
        .item {
          width: 100%;
          margin-bottom: 10px;
        }
      }
    }
    .register-btn {
      width: 100%;
    }
    .qrcode-box {
      justify-content: center;
      margin-top: 40px;
    }
    .qrLabel {
      display: none;
    }
    .download-box {
      margin-top: 40px;
    }
    .mining-btn {
      width: 100%;
    }
    .rate-label {
      margin-top: 20px;
    }
  }
  @media (min-width: 768px) {
    .banner-box {
      height: 76px;
    }
    .banner-content {
      height: 76px;
      background-position: 0px 19px;
    }
    .rate-label {
      margin-top: 50px;
    }
    .rate-text {
      font-size: 40px;
    }
    .mining-btn {
      width: 237px;
    }
    .download-box {
      margin-top: 200px;
      background-image: url("../../../public/image/home/download_bg.png");
    }
    .content-box {
      padding: 50px 40px;
    }
    .top-box {
      background-image: url("../../../public/image/home/top_phone.png");
      padding-bottom: 100px;
      padding-top: 160px;
      background-position: 94% 0px;
    }
    .swiper-slide {
      padding: 0 70px;
      line-height: 76px;
    }
    .trade-left {
      width: 58%;
      margin-right: 32px;
    }
    .trade-right {
      width: 42%;
    }
    .th-box,.td-box {
      padding:0 20px;
    }
    .mining-box {
      padding: 40px;
      .box-item {
        margin-left:40px;
        max-width: 485px;
      }
    }
    .news-box {
      .item {
        width: 33.33%;
        margin-right: 32px;
      }
    }
    .about-box {
      margin-top: 200px;
      .about-text {
        width: 55%;
        margin-top:64px;
      }
    }
    .advantages-box {
      margin-top: 160px;
      .advantages-content {
        .item {
          width: 33.33%;
          margin-right: 32px;
        }
      }
    }
    .register-btn {
      width: 520px;
    }
    .qrcode-box {
      margin-top: 100px;
    }
  }
  ._a {
    cursor: pointer;
  }
  .top-box {
    max-width: 1500px;
    margin: 0 auto;
    
  }
  
  .banner-box {
    // margin-top: 100px;
    
    background-image: url("../../../public/image/home/banner.jpg");
    background-size: 100% 100%;
    // background: #ffca00
    //   linear-gradient(187deg, #fffae8 0%, #ffe47b 5%, #faffe4 100%);
    .banner-content {
      max-width: 1500px;
      margin: 0 auto;
      background-image: url("../../../public/image/home/horn.png");
      
      .swiper-container {
        height: 100%;
        width: 100%;
      }
      .swiper-slide {
        // height: 100% !important;
        
        display: flex;
        
        .slide-item {
          flex: 1;
          font-size: 14px;
          font-weight: 600;
          color: #000000;
        }
      }
    }
  }
  .content-box {
    
    max-width: 1500px;
    margin: 0 auto;
    .trade-left {
      
      background: #1a1e25;
      border-radius: 21px 21px 21px 21px;
      .title-box {
        border-bottom: 1px solid #242831;
      }
      .th-box {
        .th-item {
          &:nth-child(1) {
            width: 26%;
          }
          &:nth-child(2) {
            width: 16%;
          }
          &:nth-child(3) {
            width: 16%;
            text-align: right;
          }
          &:nth-child(4) {
            text-align: center;
            width: 24%;
          }
          &:nth-child(5) {
            width: 18%;
            text-align: right;
          }
        }
      }
      .td-box {
        .td-item {
          &:nth-child(1) {
            width: 26%;
          }
          &:nth-child(2) {
            width: 16%;
          }
          &:nth-child(3) {
            width: 16%;
            text-align: right;
          }
          &:nth-child(4) {
            text-align: center;
            width: 24%;
          }
          &:nth-child(5) {
            width: 18%;
            text-align: right;
          }
        }
      }
    }
    .trade-right {
      background: #1a1e25;
      border-radius: 21px 21px 21px 21px;
      .title-box {
        border-bottom: 1px solid #242831;
      }
      .th-box {
        .th-item {
          &:nth-child(1) {
            width: 44%;
          }
          &:nth-child(2) {
            width: 28%;
          }
          &:nth-child(3) {
            width: 28%;
            text-align: right;
          }
        }
      }
      .td-box {
        .td-item {
          &:nth-child(1) {
            width: 44%;
          }
          &:nth-child(2) {
            width: 28%;
          }
          &:nth-child(3) {
            width: 28%;
            text-align: right;
          }
        }
      }
    }
    .th-box {
      height: 40px;
    }
    .td-box {
      height: 85px;
      &:hover {
        background: #131419;
        border-radius: 10px;
      }
      .td-item {
        .trade-btn {
          width: 100px;
          height: 40px;
          border-radius: 4px;
          border: 2px solid #ffcc0063;
          color: #ffca00;
          &:hover {
            background-color: #ffca00;
            color: #000;
          }
        }
      }
    }
    .mining-box {
      background: #1a1e25;
      border-radius: 21px 21px 21px 21px;
    
      .box-item {
        
        padding: 30px 20px;
        background: #13161b;
        border-radius: 21px 21px 21px 21px;
      }
    }
    .details-btn {
      height: 50px;
      outline: none;
      background: none;
      width: 100%;
      border: 2px solid #ffcc0063;
      color: #ffca00;
      border-radius: 4px 4px 4px 4px;

      &:hover {
        color: #000;
        background: #ffca00;
      }
    }
    .news-box {
      .item {
        
        background: #1a1e25;
        border-radius: 21px 21px 21px 21px;
        
        &:hover {
          background: #313948;
        }
        &:last-child {
          margin-right: 0;
        }
        .title-text {
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .sub-text {
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          margin-top: 40px;
          /*当文本溢出包含元素时，以省略号表示超出的文本*/
        }
      }
    }
    .about-box {
      
      background-image: url("../../../public/image/home/platform1.png");
      background-size: 100%;
      background-position: 0 100%;
      .about-text {
        
        font-size: 17px;
        font-weight: 400;
        line-height: 31px;
        color: #898c97;
      }
    }
    .advantages-box {
      
      .item {
        
        height: 471px;
        border-radius: 21px 21px 21px 21px;
        overflow: hidden;
        background-image: url("../../../public/image/home/advantage_bg.jpg");
        background-size: 100% 100%;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .download-box {
      background-position: 100% 0;
      .qrcode-box {
        
        .qrbox {
          padding: 10px 10px 2px 10px;
          background-color: #fff;
          border-radius: 6px;
        }
      }
      .btn-item {
        width: 194px;
        height: 50px;
        // background: #1d1e25;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #2b2e37;
      }
    }
  }
}
</style>